export enum PageURL {
  SPLASH = '/splash',
  PLUG_IN_SMART_HUB = '/plug-in-smart-hub',
  CONNECT_TO_SMART_HUB = '/connect-to-smart-hub',
  SELECT_UNIT = '/select-unit',
  DEVICES = '/devices',
  LOCK_TROUBLESHOOT = '/devices/lock-troubleshoot',
  CONTACT_MAINTENANCE = '/contact-maintenance',
}
